const Directions = {
  CARDINAL: [
    { x: -1, y: 0 },
    { x: 1, y: 0},
    { x: 0, y: -1 },
    { x: 0, y: 1 }
  ]
}

export default Directions;
